import { customAuth, headerAuth } from "../standardAuthPatterns";
import logo from "./logo.svg";
import { defineProduct, productVariant } from "../types";

export const pagerDuty = defineProduct({
  name: "PagerDuty",
  tagLine: "Incident management",
  logo,
  tags: ["featured", "it", "observability"],
  variants: [
    productVariant({
      identifier: "pagerDuty",
      authLabel: "REST API key",
      protocol: "http",
      defaultUrlPattern: () => "https://api\\.pagerduty\\.com/.*",
      auth: (app) =>
        headerAuth([
          {
            name: "Authorization",
            value: `Token token=${app.secret.apiKey}`,
          },
        ]),
      steps: [
        {
          title: "Get an API key",
          items: [
            {
              kind: "markdown",
              content:
                "Visit [PagerDuty](https://www.pagerduty.com/) and sign in. Navigate to **Integrations > API Access Keys** to create a new API key.",
            },
          ],
        },
        {
          title: "Copy and paste the API key into the field below",
          items: [
            {
              kind: "input",
              label: "PagerDuty API key",
              required: true,
              target: { kind: "secrets", field: "apiKey" },
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => "https://api.pagerduty.com/users?limit=1",
      },
    }),
    productVariant({
      identifier: "pagerDutyEventsApi",
      authLabel: "Events API integration key",
      protocol: "http",
      defaultUrlPattern: () => "https://events\\.pagerduty\\.com/.*",
      auth: customAuth("pagerDutyEventsApi"),
      steps: [
        {
          title: "Get an integration key",
          items: [
            {
              kind: "markdown",
              content:
                "In PagerDuty, go to **Services → Service Directory** and select the service you want to send events to. Under the **Integrations** tab, add the **Events API v2** integration and copy the **Integration Key**.\n\nThis key is used to route events to the correct service. It is different from a REST API key.",
            },
          ],
        },
        {
          title: "Paste your integration key",
          items: [
            {
              kind: "input",
              label: "Integration key",
              required: true,
              target: { kind: "secrets", field: "routingKey" },
              helperText:
                "The integration/routing key for PagerDuty Events API v2.",
            },
          ],
        },
      ],
      connectionTest: {
        protocol: "http",
        request: () => ({
          url: "https://events.pagerduty.com/v2/change/enqueue",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            payload: {
              summary: "3B connection test",
              source: "3B",
              timestamp: new Date().toISOString(),
            },
          }),
          expectedStatus: 202,
        }),
      },
    }),
  ],
});
